export default __webpack_public_path__ + "images/30cba023d6287f1a1f63e84826dd52ec.svg";